import Stat from "../../../components/Stat";
import { ToggletipText } from "../../../style";
import React from "react";
import { sendEventChartUsed } from "../../../services/dashboardAnalyticEventService";
import activitiesTypes from "../../../utils/constants/activities/activitiesTypes";
import { dashboardChartFilterAndActionTypes } from "../../../utils/constants/dashboard/analyticDashboardEvents";
import { DASHBOARD_CHART_TYPES } from "../../../utils/constants/dashboard/dashboardModuleConstants";

import DashboardChartWrapper from "../../../components/DashboardChartWrapper";
import { QueryLoaderWrapper, Skeletons } from "../../../components/Loaders";
import { CardWrapper, ItemContainer, StatsContainer } from "./style";
import useLateActivitiesCounterQuery, {
  useCalendarFilterRedirect,
} from "./useLateActivitiesCounterQuery";
import ChartActions from "@components/ChartActions/ChartActions";

const LateActivitiesCounter = () => {
  const [queryStatus, lateActivitiesCount, fetchedTime, refetch] = useLateActivitiesCounterQuery();
  const getCalendarFilterProps = useCalendarFilterRedirect();

  const header = {
    title: "Atividades atrasadas do escritório",
    description:
      "Confira a quantidade de atividades atrasadas para reorganizar as prioridades entre os responsáveis.",
  };

  const toggleTip = {
    title: "Atividades Atrasadas",
    text: (
      <ToggletipText>
        São atividades que não foram marcadas como concluídas no Astrea e ultrapassaram a data
        prevista de conclusão.
      </ToggletipText>
    ),
    onClickCallback: () => {
      sendEventChartUsed(
        DASHBOARD_CHART_TYPES.LATE_ACTIVIES_COUNTER,
        dashboardChartFilterAndActionTypes.TOGGLE_TIP_OPENED
      );
    },
    callToAction: {
      text: "Acessar central de ajuda",
      callback: () => {
        sendEventChartUsed(
          DASHBOARD_CHART_TYPES.LATE_ACTIVIES_COUNTER,
          dashboardChartFilterAndActionTypes.HELP_CENTER_CLICK
        );
        window.open(
          "https://astrea.aurum.com.br/pt-BR/articles/8043380-como-analisar-as-atividades-atrasadas-do-escritorio",
          "_blank"
        );
      },
    },
  };

  return (
    <DashboardChartWrapper
      title={header.title}
      description={header.description}
      toggleTip={toggleTip}
    >
      <ChartActions updatedAt={fetchedTime} refetchFunction={refetch} />
      <CardWrapper>
        <QueryLoaderWrapper
          queryStatus={queryStatus}
          spinnerConfig={{ height: 134, isCounter: true }}
          skeletonComponent={<Skeletons.LateActivitiesCounterSkeleton />}
        >
          <StatsContainer>
            {lateActivitiesCount.map(({ type, count }) => (
              <ItemContainer key={`${type}-${count}`}>
                <Stat
                  redValue={count > 0}
                  label={activitiesTypes[type as keyof typeof activitiesTypes].pluralLabel}
                  value={count}
                  {...{ ...getCalendarFilterProps(type) }}
                />
              </ItemContainer>
            ))}
          </StatsContainer>
        </QueryLoaderWrapper>
      </CardWrapper>
    </DashboardChartWrapper>
  );
};

export default LateActivitiesCounter;
